import React, { useState, useCallback, useRef, useEffect, useMemo  } from "react";
import { 
  GoogleMap, 
  useJsApiLoader, 
  Marker,
  DirectionsService,
  DirectionsRenderer,
  Autocomplete,OverlayView
} from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../constant";
import { Box, Chip, TextField, Typography,Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Button,Tooltip,IconButton, duration,Card,CardContent } from "@mui/material";
import DirectionsIcon from "@mui/icons-material/Directions";
import ClearIcon from "@mui/icons-material/Clear";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faSearch, faUser } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useToastActions } from "../customcomponents/CustomToast";
import api from '../api';
import {useMediaQuery} from "@mui/material";
import CustomSearchinput from '../customcomponents/CustomSearchInput';

// Keep libraries array as a static constant to avoid recreating it on each render
const LIBRARIES = ["places"];

const containerStyle = {
  width: "100%",
  height: "88vh",
  overflow: "hidden",
};

// Define a custom pin icon for user or admin locations
const pinIcon = {
  url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
  scaledSize: {
    width: 40,
    height: 40
  }
};

// Defines a custom pin icon for patients locations
const patientPinIcon = {
  url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
  scaledSize: {
    width: 40,
    height: 40
  }
};
const FloatingPanel = ({ open, onClose, onClear, title, children, anchor="center" }) => {
  if (!open) return null;

  return (
    <>
      <Box
          onClick={onClose}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 1190,      // lower than panel, higher than map
          }}
        />
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: "absolute",
          top: { xs: 85, md: "45px" },
          left: {
            xs:
              anchor === "left"
                ? "35%"
                : anchor === "center"
                ? "50%"
                : anchor === "right"
                ? "65%"
                : "50%",
            md:
              anchor === "left"
                ? "50%"
                : anchor === "center"
                ? "60%"
                : anchor === "right"
                ? "70%"
                : "50%",
          },

          transform: "translateX(-50%)",
          width: { xs: "45vw", md: 300 },
          maxWidth: "330px",
          borderRadius: 2,
          bgcolor: "#fffffff1",
          backdropFilter: "blur(4px)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          zIndex: 1200,
          animation: "fadeSlide .2s ease-out",
          "@keyframes fadeSlide": {
            from: { opacity: 0, transform: "translate(-50%, -10px)" },
            to: { opacity: 1, transform: "translate(-50%, 0)" }
          }
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 1,
            py: 0.5,
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "#fafafa90",
          }}
        >
          <Typography fontWeight="bold" sx={{ fontSize: { xs: "0.75rem", md: "1.1rem" } }}>
            {title}
          </Typography>

          <Button size="small" variant="outlined" onClick={onClear}
            sx={{ fontSize: { xs: "0.5rem", md: "0.75rem" }, px: 1 }}
          >
            Clear
          </Button>
        </Box>

        {/* Body */}
        <Box
          sx={{
            maxHeight: { xs: "35vh", md: "220px" },
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-thumb": { backgroundColor: "#b0b0b0", borderRadius: "2px" },
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};

// Pick the correct pin by role
const getPinIcon = (role) =>role === 'Patient' ? patientPinIcon : pinIcon;

function GoogleMapPage({ data }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
    version: "weekly",
    region: "IN",
    language: "en",
  });
  // console.log("DEBUG → isLoaded:", isLoaded, "loadError:", loadError);
  
  
  // const inputRef = useRef(null);
  // const autocompleteRef = useRef(null);
  const mapRef = useRef(null);
  const locationPath = useLocation();
  const toast = useToastActions();
  
  const [directions, setDirections] = useState(null);
  const [routeError, setRouteError] = useState(null);
  const [lastSelected, setLastSelected] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [showUsers, setShowUsers] = useState(false);
  const [selectedVendorId,setSelectedVendorId]=useState(null);
  const [selectedCustomerId,setSelectedCustomerId]=useState(null);
  const [selectedServiceId,setSelectedServiceId]=useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [showDirectionsButton, setShowDirectionsButton] = useState(false);
  const [selectionMessage, setSelectionMessage] = useState('');
  const [services, setServices] = useState([]);
  const [showServices, setShowServices] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:800px)");
  const [infoWindowPos, setInfoWindowPos] = useState(null);
  const [infoWindowData, setInfoWindowData] = useState(null);


  //  local state to toggle each accordion
  const [showPatients, setShowPatients] = useState(false);
  // state for autocomplete instance
  const [autocompleteInstance, setAutocompleteInstance] = useState(null);

  //  split incoming data into users/patients
  // const usersData = useMemo(() => (data || []).filter(d => d?.role !== 'Patient'), [data]);
  // const patientsData = useMemo(() => (data || []).filter(d => d?.role === 'Patient'), [data]);

  // for search and filter
  const [search, setSearch] = useState('');


  const usersData = useMemo(() => {
  let list = (data || []).filter(d => d?.role !== 'Patient');
  // console.log('list:',list);

  if (selectedServiceId) {
      list = list.filter(u =>
        u.serviceRef?.some(s => s._id === selectedServiceId)
      );
    }

    return list;
  }, [data, selectedServiceId]);

  const filteredUsers = useMemo(() => {
    if (!search.trim()) return usersData;

    const q = search.toLowerCase();

    return usersData.filter((u) =>
      u.name?.toLowerCase().includes(q) ||
      u.phone?.toLowerCase().includes(q) ||
      u.email?.toLowerCase().includes(q)
    );
  }, [usersData, search]);

  const patientsData = useMemo(() => {
    let list = (data || []).filter(d => d?.role === 'Patient');

    if (selectedServiceId) {
      list = list.filter(pt =>
        pt.serviceRef?.some(ref =>
          ref.serviceId?._id === selectedServiceId
        )
      );
    }

    return list;
  }, [data, selectedServiceId]);

  const filteredPatients = useMemo(() => {
    if (!search.trim()) return patientsData;

    const q = search.toLowerCase();

    return patientsData.filter((pt) =>
      pt.name?.toLowerCase().includes(q) ||
      pt.phone?.toLowerCase().includes(q) ||
      pt.email?.toLowerCase().includes(q)
    );
  }, [patientsData, search]);

  // console.log('vendors:',usersData);
  // console.log('customers:',patientsData);
  //  counts for chips
  const usersCount = usersData.length;
  const patientsCount = patientsData.length;

  // Find the role of the selected place (if it comes from our data)
    const selectedPlaceRole = useMemo(() => {
      if (!selectedPlace) return null;
      if (!data || !data.length) return null;

      const match = data.find(d =>
        Number(d.latitude) === Number(selectedPlace.lat) &&
        Number(d.longitude) === Number(selectedPlace.lng)
      );

      return match?.role || null;
    }, [selectedPlace, data]);

  // Memoize locations to prevent unnecessary recalculations
  const locations = useMemo(() => 
    data?.map(loc => ({
      lat: Number(loc.latitude),
      lng: Number(loc.longitude)
    })) || []
  , [data]);  
  
  const center = useMemo(() => {
    if (selectedPlace) return selectedPlace;
    return {
      lat:  20.5937,
      lng:  78.9629,
    };
  }, [selectedPlace,locations]);
  const zoom = selectedPlace ? 14 : 5;

const directionsRendererRef = useRef(null);

  const calculateRoute = useCallback((origin, destination) => {
    if (!window.google) return;
    setRouteError(null);
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
          if (!directionsRendererRef.current) {
            directionsRendererRef.current = new window.google.maps.DirectionsRenderer();
            directionsRendererRef.current.setMap(mapRef.current);
          }
          directionsRendererRef.current.setDirections(result);
        } else {
          const errorMessage="Cannot Calculate route to destination!";
          setRouteError(errorMessage);
          toast.error(errorMessage);
          setDirections(null);
          setSelectedLocations([]);
          setShowDirectionsButton(false);
        }
      }
    );
  }, []);

  const clearSelection = () => {
    const last=lastSelected;
    setSelectedLocations([]);
    setShowDirectionsButton(false);
    setRouteError(null);
    setDirections(null);

    // Properly clear the directions renderer
    if (directionsRendererRef.current) {
      directionsRendererRef.current.setDirections(null); // Clear directions
      directionsRendererRef.current.setMap(null); // Remove from map
      directionsRendererRef.current = null;
    }
    // console.log(locations);
    
  if (last && mapRef.current) {
      mapRef.current.panTo(last);
      mapRef.current.setZoom(7);

      // Keep this location highlighted
      // setSelectedPlace(last);

      return;
    }
    if (mapRef.current) {
      mapRef.current.panTo({
        lat:  20.5937,
        lng:  78.9629,
      });
      mapRef.current.setZoom(5); // Adjust zoom level as needed
    }
  };

  // handler function for autocomplete load
  const handleAutocompleteLoad = (ac) => {
  setAutocompleteInstance(ac);
};

const handleAutocompletePlaceChanged = () => {
  try {
    if (!autocompleteInstance) return;

    const place = autocompleteInstance.getPlace();
    if (!place?.geometry?.location) {
      toast.error("Please select a location from the dropdown list");
      return;
    }

    const newLoc = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    setSelectedPlace(newLoc);

    if (mapRef.current) {
      mapRef.current.panTo(newLoc);
      const zoomLevel = place.geometry.viewport ? 15 : 17;
      mapRef.current.setZoom(zoomLevel);
    }
  } catch (error) {
    console.error("Error handling place selection:", error);
    toast.error("Error selecting location. Please try again.");
  }
};

//  useeffect for the for the service send form the interaction page 

useEffect(() => {
  if (!locationPath?.state || !locationPath.state.fromAssignBroadcast) return;

  const { patientId, serviceId, message } = locationPath.state;

  // Pre-select service on the map (filters vendors/patients by that service)
  if (serviceId) {
    setSelectedServiceId(serviceId);
    // setShowServices(true);
  }

  // Pre-select customer if it exists in your patients data
  if (patientId) {
    setSelectedCustomerId(patientId);
    // setShowPatients(true);
  }

  // Show the message in the bottom selection bar
  if (message) {
    setSelectionMessage(message);
    // Optional: auto clear after a few seconds
    const t = setTimeout(() => setSelectionMessage(''), 8000);
    return () => clearTimeout(t);
  }
}, [locationPath]);


 
  // Calculate route when locations change and map is loaded
 
 
  useEffect(() => {
    if (isLoaded && locations.length >= 2) {
      calculateRoute();
    } else {
      setDirections(null);
    }
  }, [isLoaded, locations, calculateRoute]);

  const fetchServices = async () => {
    try {
      const res = await api.get('/services');
      let servicesArr = [];
      if (Array.isArray(res.data.data)) {
        servicesArr = res.data.data.map(s => ({
          _id: s._id,  // Use _id to match MongoDB field name
          name: s.TA_Service_Name,
          status: s.TA_Service_Status === 1 ? 'Active' : 'Inactive',
          // Add other fields as needed
        }));
      }
      setServices(servicesArr);
      // console.log(servicesArr);
      return servicesArr; // Return the services for use in other functions
    } catch (err) {
      setServices([]);
      console.error('Failed to fetch services:', err);
      return [];
    }
  };

  useEffect(() => {
    fetchServices(); // load services on first load
  }, []);


   const filteredServices = useMemo(() => {
      if (!search.trim()) return services;

      const q = search.toLowerCase();

      return services.filter((srv) =>
        srv.name?.toLowerCase().includes(q) ||
        srv.status?.toLowerCase().includes(q)
      );
    }, [services, search]);


  // Initialize Google Places Autocomplete
  //   useEffect(() => {
  //   if (!isLoaded || !inputRef.current || !window.google || !window.google.maps.places) {
  //     console.warn("Google Places API not loaded");
  //     return;
  //   }

  //   try {
  //     // Clean up previous autocomplete instance
  //     if (autocompleteRef.current) {
  //       window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
  //     }

  //     // Initialize Places Autocomplete with enhanced options
  //     autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
  //       fields: ["geometry", "name", "formatted_address", "place_id"],
  //       componentRestrictions: { country: "in" },
  //       types: ['geocode', 'establishment'],
  //     });

  //     const onPlaceChanged = () => {
  //       try {
  //         const place = autocompleteRef.current.getPlace();
  //         if (!place?.geometry?.location) {
  //           toast.error("Please select a location from the dropdown list");
  //           return;
  //         }

  //         const newLoc = {
  //           lat: place.geometry.location.lat(),
  //           lng: place.geometry.location.lng(),
  //         };
  //         setSelectedPlace(newLoc);

  //         if (mapRef.current) {
  //           mapRef.current.panTo(newLoc);
  //           // Adjust zoom based on the type of place
  //           const zoomLevel = place.geometry.viewport ? 15 : 17;
  //           mapRef.current.setZoom(zoomLevel);
  //         }
  //       } catch (error) {
  //         console.error("Error handling place selection:", error);
  //         toast.error("Error selecting location. Please try again.");
  //       }
  //     };

  //   autocompleteRef.current.addListener("place_changed", onPlaceChanged);

  //   return () => {
  //     if (autocompleteRef.current) {
  //       window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
  //     }
  //   };
  // }catch (error) {
  //     console.error("Error initializing Places Autocomplete:", error);
  //     toast.error("Error initializing location search. Please refresh the page.");
  // }
  // }, [isLoaded, toast]); 



  // Handle map load
  const handleMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  // Clear selected place when data changes
  useEffect(() => {
    setSelectedPlace(null);
  }, [data]);

  if (loadError) {
    return (
      <div style={{ color: 'red', padding: '20px', textAlign: 'center', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: '8px', margin: '32px auto', maxWidth: '500px' }}>
        <strong>Failed to load Google Maps.</strong><br />
        Please check your internet connection and API key configuration.<br />
        <span style={{ fontSize: '0.9em', color: '#ad8b00' }}>
          If you are the developer, verify your API key is valid, enabled for Maps JavaScript API and Places API, and not restricted for this domain.
        </span>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#555' }}>
        Loading Google Maps...
      </div>
    );
  }

  const renderMarkers = (dataArray) => {
  return dataArray.map((item, idx) => (
    <Marker
      key={`marker-${idx}-${item.latitude}-${item.longitude}`}
      position={{
        lat: Number(item.latitude),
        lng: Number(item.longitude)
      }}
      icon={getPinIcon(item?.role)}
      onClick={() => {
        setInfoWindowPos({
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        });
        setInfoWindowData({
          name: item.name,
          email: item.email || item.address || "No details",
          phone: item.mobile || item.phone || "",
          role: item.role
        });
      }}
      onDblClick={() => {
        setInfoWindowPos(null);
        const loc = {
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        };

        if (
          selectedLocations.length < 2 &&
          !selectedLocations.find(s => s.lat === loc.lat && s.lng === loc.lng)
        ) {
          const updated = [...selectedLocations, loc];
          setSelectedLocations(updated);
          setLastSelected(loc);

          if (updated.length === 1) {
            toast.info("Select another location to find route");
          }
          if (updated.length === 2) setShowDirectionsButton(true);
        }
      }}
    />
  ));
};





  return (
    <>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onLoad={handleMapLoad}
        options={{
          streetViewControl: true,
          mapTypeControl: isSmallScreen?false:true,
          fullscreenControl: isSmallScreen?false:true,
        }}
        onClick={()=>setInfoWindowPos(null)}
      >
        {/* Search and Controls Container - Fixed for mobile */}
        <Box sx={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          // position: 'relative',
          // top: { xs: 55, md: 10 },
          // left: 0,
          // right: 0,
          // zIndex: 1000,
          gap: { xs: 1, md: 2 },
          px: { xs: 1, md: 2 },
        }}>
          {/* Search Box Container */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            // width: {xs:'800px',md:'300px'},  
            width: { xs: '100%', md: 300 },
            zIndex:1000,
            position: 'relative',
            top: { xs: 5, md: 10 },
            left: 0,
            right: 0,
            zIndex: 1000,
          }}>
            <Autocomplete
            onLoad={handleAutocompleteLoad}
            onPlaceChanged={handleAutocompletePlaceChanged}
            options={{
              fields: ["geometry", "name", "formatted_address", "place_id"],
              // componentRestrictions: { country: "us" },
              types: ["geocode", "establishment"],
            }}
          >
            <input
              type="text"
              placeholder="Search"
              autoComplete="on"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              style={{
                borderRadius: '20px',
                background: isFocused || isHovered ? '#2c2c2c41' : '#00000057',
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                color: 'white',
                padding: '8px 16px',
                width: '100%',
                maxWidth: '300px',
                marginTop: '0'
              }}
            />
          </Autocomplete>
            <Box sx={{ 
              position: 'relative', 
              right: '30px',
              marginTop: '0'
            }}>
              <FontAwesomeIcon icon={faSearch} style={{ color: "#fff" }} />
            </Box>
          </Box>

          <Box sx={{display:'flex',flexDirection:'row',}}>


            {/* Services Chip */}
            <Box sx={{ 
              display: 'flex', 
              flex:1,
              justifyContent: 'center',
              width: { xs: 'fit-content', md: 'auto' },
              position: 'relative',
              top: { xs: 5, md: 10 },
              left: -10,
              right: 0,
              zIndex: 1000,
            }}>
              
                <Chip
                  icon={
                    <Typography variant="subtitle1" ml={1.5} fontWeight="bold">
                      {services.length}
                    </Typography>
                  }
                  label="Services"
                  onClick={() => {setShowServices(prev => !prev); setShowPatients(false);setShowUsers(false);}}
                  sx={{
                    px: 1,
                    py: 0.5,
                    color: "#000",
                    backgroundColor: "#fff",
                    boxShadow: 2,
                    borderRadius: "16px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    ml: { xs: 1, md: 2 }
                  }}
                />
              
            </Box>
            

              {/* Customer Chip */}
              <Box sx={{ 
                display: 'flex', 
                flex:1,
                justifyContent: 'center',
                width: { xs: 'fit-content', md: 'auto' },
                position: 'relative',
                top: { xs: 5, md: 10 },
                left: -10,
                right: 0,
                zIndex: 1000,
              }}>
                {isSmallScreen?(
                    <Box
                    onClick={() => {setShowPatients(prev => !prev); setShowServices(false); setShowUsers(false);}}
                    sx={{
                      display: { xs: "flex", md: "none" },
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      boxShadow: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      }
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold" color={'#0977d1ff'}>
                      {patientsCount}
                    </Typography>
                  </Box>  
                ):(
                  <Chip
                    icon={
                      <Typography variant="subtitle1" ml={1.5} fontWeight="bold">
                        {patientsCount}
                      </Typography>
                    }
                    label="Customers"
                    onClick={() => {setShowPatients(prev => !prev); setShowServices(false); setShowUsers(false);}}
                    sx={{
                      px: 1,
                      py: 0.5,
                      color: "#000",
                      backgroundColor: "#fff",
                      boxShadow: 2,
                      borderRadius: "16px",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                      ml: { xs: 1, md: 2 }
                    }}
                  />
                )}
              </Box>


              {/* Vendor Chip */}
              <Box sx={{ 
                display: 'flex', 
                flex:1,
                justifyContent: 'center',
                width: { xs: 'fit-content', md: 'auto' },
                position: 'relative',
                top: { xs: 5, md: 10 },
                left: 10,
                right: 0,
                zIndex: 1000,
              }}>
                {isSmallScreen?(
                  <Box
                    onClick={() => { 
                      setShowUsers(prev => !prev);
                      setShowPatients(false);
                      setShowServices(false);
                    }}
                    sx={{
                      display: { xs: "flex", md: "none" },
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      boxShadow: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      }
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold" color={'red'}>
                      {usersCount}
                    </Typography>
                  </Box>
                ):(
                  <Chip
                    icon={
                      <Typography variant="subtitle1" ml={1.5} fontWeight="bold">
                        {usersCount}
                      </Typography>
                    }
                    label="Vendors"
                    onClick={() => { setShowUsers(prev => !prev);setShowPatients(false);setShowServices(false); }}
                    sx={{
                      px: 1,
                      py: 0.5,
                      color: "#000",
                      backgroundColor: "#fff",
                      boxShadow: 2,
                      borderRadius: "16px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  />
                )}
  
              </Box>

          </Box>
          {/* Services Accordion - Mobile Responsive */}
          {showServices && (
            <FloatingPanel
              open={showServices}
              onClose={() => {
                setShowServices(false);
                setSearch(''); 
              }}
              onClear={()=>{
                setShowServices(false);
                setSelectedServiceId(null);
                setSelectedPlace(null);
                // calculateRoute();
                setInfoWindowPos(null)
                setSearch(''); 
              }}
              title="Services List"
              anchor="left"
            >
                <Box sx={{position: "sticky", top: 0, zIndex: 2, bgcolor: "#ffffff", px: 2, py: 1.5, borderBottom: "1px solid #e5e7eb",}}>
                  <CustomSearchinput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus/>
                </Box>
                {filteredServices?.length === 0 ? (
                  <List dense>
                    <ListItem>
                      <Typography  sx={{
                        textAlign: "center",
                        fontSize: { xs: "0.6rem", md: "0.9rem" },
                        color: "text.secondary",
                      }}>No Services found</Typography>
                    </ListItem>
                  </List>
                  ):(
                  <List dense>
                    {filteredServices.map((srv, idx) => (
                      <ListItem
                        key={srv._id || idx}
                        sx={{
                          px: { xs: 1.2, md: 2.5 }, // tighter padding
                          "&:hover": { bgcolor: "#f7f7f7" },
                          borderBottom: "1px solid #eee",
                          bgcolor: selectedServiceId === srv._id ? "#e6f2ff" : "transparent",
                        }}
                        onClick={() => {
                          setSelectedServiceId(srv._id);   // store selected service
                          // setShowServices(false);
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              fontWeight="600"
                              textTransform="capitalize"
                              sx={{ fontSize: { xs: "0.6rem", md: "1rem" } }}
                            >
                              {srv.name}
                            </Typography>
                          }
                          secondary={
                            <Typography sx={{ fontSize: { xs: "0.45rem", md: "0.875rem" } }}>
                              Status: {srv.status}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </FloatingPanel>
          )}

          {/* Customer Accordion - Mobile Responsive */}
          {showPatients && (
            <FloatingPanel
                open={showPatients}
                onClose={() => {
                  setShowPatients(false);
                  setSearch(''); 
                }}
                onClear={()=>{
                  setShowPatients(false);
                  setSelectedCustomerId(null);
                  setSelectedPlace(null);
                  // calculateRoute();
                  setInfoWindowPos(null)
                  setSearch(''); 
                }}
                title="Customers List"
                anchor="center"
              >
                <Box sx={{position: "sticky", top: 0, zIndex: 2, bgcolor: "#ffffff", px: 2, py: 1.5, borderBottom: "1px solid #e5e7eb",}}>
                  <CustomSearchinput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus/>
                </Box>
              {filteredPatients?.length === 0 ? (
                <List dense>
                  <ListItem>
                    <Typography  sx={{
                      textAlign: "center",
                      fontSize: { xs: "0.6rem", md: "0.9rem" },
                      color: "text.secondary",
                    }}>No customers found</Typography>
                  </ListItem>
                  </List>
              ) : (
                <List dense>
                  {filteredPatients?.map((pt, index) => (
                    <ListItem
                      key={pt?.id || index}
                      disablePadding
                      sx={{
                        px: { xs: 1.2, md: 2.5 }, // tighter padding
                        "&:hover": { bgcolor: "#f7f7f7" },
                        borderBottom: "1px solid #eee",
                        bgcolor: selectedCustomerId === pt.id ? "#e6f2ff" : "transparent",
                      }}
                      onClick={() => {
                        setSelectedCustomerId(pt.id);
                        const newLoc = {
                          lat: Number(pt.latitude),
                          lng: Number(pt.longitude),
                        };
                        setSelectedPlace(newLoc);
                        if (mapRef.current) {
                          mapRef.current.panTo(newLoc);
                          mapRef.current.setZoom(14);
                          setDirections(null);
                        }
                        setShowPatients(false);
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            fontWeight="600"
                            textTransform="capitalize"
                            sx={{ fontSize: { xs: "0.6rem", md: "1rem" } }}
                          >
                            {pt.name}
                          </Typography>
                        }
                        secondary={
                          <Typography
                            sx={{ fontSize: { xs: "0.45rem", md: "0.875rem" } }}
                          >
                            { pt.email || "N/A"}
                          </Typography>
                        }
                      />

                      <Chip
                        label="Customer"
                        color="success"
                        variant="outlined"
                        size="small"
                        sx={{
                          fontSize: { xs: "0.45rem", md: "0.75rem" },
                          height: { xs: 18, md: 24 },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
              </FloatingPanel>
          )}

          {/* Vendors Accordion - Mobile Responsive */}
          {showUsers && (
            <FloatingPanel
                open={showUsers}
                onClose={() => {
                  setShowUsers(false);
                  setSearch(''); 
                }}
                onClear={()=>{
                  setShowUsers(false);
                  setSelectedVendorId(null);
                  setSelectedPlace(null);
                  calculateRoute();
                  setInfoWindowPos(null);
                  setSearch('');
                }}
                title="Vendors List"
                anchor="right"
              >
                <Box sx={{position: "sticky", top: 0, zIndex: 2, bgcolor: "#ffffff", px: 2, py: 1.5, borderBottom: "1px solid #e5e7eb",}}>
                  <CustomSearchinput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus/>
                </Box>
                {filteredUsers?.length === 0 ? (
                <List dense>
                  <ListItem>
                    <Typography  sx={{
                      textAlign: "center",
                      fontSize: { xs: "0.6rem", md: "0.9rem" },
                      color: "text.secondary",
                    }}>No vendors found</Typography>
                  </ListItem>
                  </List>
              ) :(
                <List dense>
                  {filteredUsers?.map((user, index) => (
                    <ListItem
                      key={user?.id || index}
                      disablePadding
                      sx={{
                        px: { xs: 1.2, md: 2.5 },            // even tighter padding
                        "&:hover": { bgcolor: "#f7f7f7" },
                        borderBottom: "1px solid #eee",
                        bgcolor: selectedVendorId === user.id ? "#e6f2ff" : "transparent",
                      }}
                      onClick={() => {
                        setSelectedVendorId(user.id);
                        setInfoWindowPos(null);
                        const newLoc = {
                          lat: Number(user.latitude),
                          lng: Number(user.longitude),
                        };
                        setSelectedPlace(newLoc);

                        if (mapRef.current) {
                          mapRef.current.panTo(newLoc);
                          mapRef.current.setZoom(14);
                          setDirections(null);
                        }
                        setShowUsers(false);
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography 
                            fontWeight="600" 
                            textTransform="capitalize"
                            sx={{ fontSize: { xs: "0.6rem", md: "1rem" } }} // smaller name text
                          >
                            {user.name}
                          </Typography>
                        }
                        secondary={
                          <Typography sx={{ fontSize: { xs: "0.45rem", md: "0.875rem" } }}>
                            {user.email || user.address || "N/A"}
                          </Typography>
                        }
                      />

                      <Chip 
                        label={user.role} 
                        size="small" 
                        sx={{ fontSize: { xs: "0.45rem", md: "0.75rem" }, height: { xs: 18, md: 24 } }} 
                      />
                    </ListItem>
                  ))}
                </List>
              )}
              </FloatingPanel>
          )}

        </Box>

        {/* Markers */}
        {selectedPlace ? (
          <Marker 
            position={selectedPlace} 
            icon={getPinIcon(selectedPlaceRole)}
            title="Selected Location"
            onClick={() => {
              // Find the corresponding user data for the selected place
              const selectedUser = data?.find(user => 
                Number(user.latitude) === Number(selectedPlace.lat) &&
                Number(user.longitude) === Number(selectedPlace.lng)
              );
              
              if (selectedUser) {
                // Show info window with user data
                setInfoWindowPos(selectedPlace);
                setInfoWindowData({
                  name: selectedUser.name,
                  email: selectedUser.email || selectedUser.address || "No details",
                  phone: selectedUser.mobile || selectedUser.phone || "",
                  role: selectedUser.role
                });
              } else {
                // Show basic info for searched places (not from our data)
                setInfoWindowPos(selectedPlace);
                setInfoWindowData({
                  name: "Searched Location",
                  email: "Custom search result",
                  phone: "",
                  role: "Location"
                });
              }
            }}
            onDblClick={() => {
              setInfoWindowPos(null);
              if (selectedLocations.length < 2) {
                const updated = [...selectedLocations, selectedPlace];
                setSelectedLocations(updated);
                setLastSelected(selectedPlace);

                if (updated.length === 1) {
                  toast.info("Select another location to find route");
                }
                if (updated.length === 2) setShowDirectionsButton(true);
              }
            }}
          />
        ) : selectedServiceId ? (
          <>
            {renderMarkers(usersData)}
            {renderMarkers(patientsData)}
          </>
        ) : (
          renderMarkers(data || [])
        )}

        {/* Directions Controls - Mobile Responsive */}
        {showDirectionsButton && (
          <Box sx={{
            position: "absolute",
            top: { xs: 90, md: 80 },
            left: { xs: 5, md: 20 },
            zIndex: 2000,
            display: "flex",
            gap: 1,
            bgcolor: "white",
            p: 0.5,
            borderRadius: "8px",
            boxShadow: 3,
          }} >
            <Tooltip title="Show Directions">
              <IconButton
                color="primary"
                onClick={() => {
                  const [origin, destination] = selectedLocations;
                  calculateRoute(origin, destination);
                }}
                sx={{ 
                  bgcolor: "white", 
                  "&:hover": { bgcolor: "#e3f2fd" },
                  fontSize: { xs: '1.2rem', md: '1.5rem' }
                }}
                size={window.innerWidth < 600 ? "small" : "medium"}
              >
                <DirectionsIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Clear Selection">
              <IconButton
                color="error"
                onClick={clearSelection}
                sx={{ 
                  bgcolor: "white", 
                  "&:hover": { bgcolor: "#ffebee" },
                  fontSize: { xs: '1.2rem', md: '1.5rem' }
                }}
                size={window.innerWidth < 600 ? "small" : "medium"}
              >
                <ClearIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Box>
        )}

        {/* Selection Message - Mobile Responsive */}
        {selectionMessage && (
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 70, md: 60 },
              left: { xs: 10, md: 10 },
              right: { xs: 10, md: 'auto' },
              zIndex: 2000,
              bgcolor: "rgba(0, 0, 0, 0.8)",
              color: "white",
              p: 1.5,
              borderRadius: "8px",
              boxShadow: 3,
              textAlign: "center",
              minWidth: { xs: "calc(100vw - 40px)", md: "250px" },
              maxWidth: { xs: "calc(100vw - 40px)", md: "300px" },
            }}
          >
            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
              {selectionMessage}
            </Typography>
          </Box>
        )}
        {infoWindowPos && (
          <OverlayView
            position={infoWindowPos}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <Box
              sx={{
                position: "absolute",
                transform: "translate(-50%, -120px)", // PERFECT ABOVE MARKER
                zIndex: 9999,
                pointerEvents: "auto"
              }}
            >
              <Card
                elevation={3}
                sx={{
                  minWidth: 140,
                  maxWidth: 160,
                  borderRadius: 1.5,
                  padding: "4px 8px",
                }}
              >
                <CardContent sx={{ padding: "4px !important" }}>
                  {/* NAME */}
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      textTransform: "capitalize",
                      lineHeight: 1.2
                    }}
                  >
                    {infoWindowData?.name}
                  </Typography>

                  {/* EMAIL */}
                  <Typography
                    sx={{
                      fontSize: "0.65rem",
                      color: "text.secondary",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      lineHeight: 1.2,
                      mt: 0.2
                    }}
                  >
                    {infoWindowData?.email}
                  </Typography>

                  {/* PHONE */}
                  {infoWindowData?.phone && (
                    <Typography
                      sx={{
                        fontSize: "0.65rem",
                        mt: 0.2,
                        lineHeight: 1.2
                      }}
                    >
                      📞 {infoWindowData.phone}
                    </Typography>
                  )}

                  {/* ROLE */}
                  <Chip
                    label={infoWindowData?.role}
                    size="small"
                    sx={{
                      mt: 0.5,
                      height: 18,
                      fontSize: "0.6rem",
                      background:
                        infoWindowData?.role === "Patient"
                          ? "#e3f2fd"
                          : "#ffebee",
                      color:
                        infoWindowData?.role === "Patient"
                          ? "#0d47a1"
                          : "#c62828",
                      fontWeight: 600,
                    }}
                  />
                </CardContent>
              </Card>

              {/* ARROW POINTER (CENTERED) */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: "-8px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "6px solid transparent",
                  borderRight: "6px solid transparent",
                  borderTop: "6px solid white",
                  filter: "drop-shadow(0 -1px 1px rgba(0,0,0,0.2))",
                }}
              />
            </Box>
          </OverlayView>
        )}
        
        {/* {directions && <DirectionsRenderer directions={directions} />} */}
      </GoogleMap>
    </>
  );
}

export default React.memo(GoogleMapPage);